import LinearGradient from "@src/lib/ui/LinearGradient";
import { gradientsArray } from "@src/lib/utils/color";
import { emojiToNumber } from "@src/lib/utils/strings";
import { FC, useMemo } from "react";

type Props = {
  emoji: string;
};

const HEIGHT = 180;

const EmojiPreview: FC<Props> = ({ emoji }) => {
  const linearGradient = useMemo(() => {
    return gradientsArray[emojiToNumber(emoji) % gradientsArray.length];
  }, [emoji]);

  return (
    <div className="relative flex h-[180px] w-full items-center justify-center overflow-hidden rounded-3xl">
      <div className="absolute inset-0 z-[1] blur-[10px]">
        <LinearGradient
          height={HEIGHT}
          width={"100%"}
          x1={HEIGHT}
          colors={linearGradient}
        />
      </div>
      <div className="relative z-[2] flex size-full flex-1 items-center justify-center self-stretch">
        <span className="text-3xl-v4">{emoji}</span>
      </div>
    </div>
  );
};

export default EmojiPreview;
